import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import "react-nice-dates/build/style.css";
import Button from "../../components/UI/Button";
import { fullHouseText, RoomReservation } from "../../ostertalertypes";
import StepSingleRoom from "./StepSingleRoom";
import { useStepperContext } from "./StepperContext";


export const StepMultipleRooms: React.FC = (props) => {
  const stepperCtx = useStepperContext();

  function onAddRoom() {
    if (stepperCtx.activeBooking.length < stepperCtx.selectedHouse!.rooms.size) {
      const nextRoomName = stepperCtx.getNextAvailableRoomName();
      if (nextRoomName && nextRoomName.roomName !== fullHouseText) {
        stepperCtx.addRoom(nextRoomName);
      }
    }
  }

  function onRemoveRoom() {
    if (stepperCtx.activeBooking.length > 1)
      stepperCtx.removeRoom();
  }

  const onBookingChanged = (appartment: RoomReservation, index: number) => {
    stepperCtx.updateRoom(appartment, index)
  };

  return (
    <>
      {stepperCtx.activeBooking.map((roomState, index) => (
        <div className="p-4 rounded shadow-md mt-5 border border-gray-200">
          <StepSingleRoom
            key={index}
            availableRooms={stepperCtx.filterAvailableRooms(roomState.roomName)}
            index={index}
            roomState={roomState}
            onRoomUpdated={onBookingChanged}
            houseName={stepperCtx.selectedHouse!.houseName}
          />
        </div>
      ))}
      {stepperCtx.activeBooking[0].roomName !== fullHouseText && <>
        <p className="mt-10 text-gray-500">
          {`Bitte fügen Sie jetzt alle Zimmer hinzu die Sie für ihren Aufenthalt in ${stepperCtx.selectedHouse!.houseName} reservieren möchten.`}
        </p>
        <div className="flex space-x-2 items-center justify-between content-center bg-slate-100 mt-5 p-4 text-slate-600 font-medium  leading-tight rounded shadow-md">
          <p>Jetzt weiteres Zimmer hinzufügen</p>
          <div className="flex space-x-1">
            <Button onClick={onAddRoom} title="Zimmer hinzufügen" disabled={stepperCtx.activeBooking[0].roomName === fullHouseText}>
              <FontAwesomeIcon icon={faPlus} />
            </Button>
            <Button onClick={onRemoveRoom} title="Zimmer entfernen" disabled={stepperCtx.activeBooking[0].roomName === fullHouseText}>
              <FontAwesomeIcon icon={faMinus} />
            </Button>
          </div>
        </div> </>}
    </>
  );
};
